<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="siteManageTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="isPublish" slot-scope="data">
          <span>{{ data.row.isPublish === 1 ? '正常' : '禁用' }}</span>
        </template>
        <template slot="wtFormTableListButtonsAfter" slot-scope="scope">
           <wt-auth v-if="scope.row.isPublish" :hasAnyPremission="form.formCode + ':USABLE'" class="search-form-btn">
             <el-button size="mini" type="primary" @click="toClickAction(scope.row)">禁用</el-button>
           </wt-auth>
           <wt-auth v-if="!scope.row.isPublish" :hasAnyPremission="form.formCode + ':USABLE'" class="search-form-btn">
             <el-button size="mini" type="primary" @click="toClickAction(scope.row)">启用</el-button>
           </wt-auth>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
export default {
  name: 'SiteIndex',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_SITE_INDEX',
        formComponent: {
          list: { type: 'default', value: '/modules/site/siteList' },
          delete: { type: 'default', value: '/modules/site/siteDelete' },
          add: { type: 'component', componentName: 'SiteIndexEditPage', value: 'resetSiteDetailData', detailData: {}},
          edit: { type: 'component', componentName: 'SiteIndexEditPage', value: 'setSiteDetailData', detailData: {}},
          view: { type: 'component', componentName: 'SiteIndexViewPage', value: 'setSiteDetailData', detailData: {}}
        },
        formInputsData: [
          { name: '站点名称', key: 'name', value: '', type: 'text' },
          { name: '机构', key: 'orgId', value: '', type: 'cascader', options: [], props: { checkStrictly: true, children: 'childList', label: 'name', value: 'id', emitPath: false, expandTrigger: 'hover' }},
          { name: '状态',
            key: 'isPublish',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '正常', value: 1 },
              { label: '禁用', value: 0 }
            ] }],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', className: 'danger', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '站点名称', key: 'name', type: 'text' },
          { name: '社区名称', key: 'communityName', type: 'text' },
          { name: '物业总名称', key: 'name1', type: 'text' },
          { name: '物业分名称', key: 'name2', type: 'text' },
          { name: '项目部', key: 'name3', type: 'text' },
          { name: '站点位置', key: 'address', type: 'text' },
          { name: '状态', key: 'isPublish', type: 'custom' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonWidth: 190 }
      },
      formDialog: {
        visible: true,
        title: ''
      }
    }
  },
  mounted() {
    this.orgListSelect()
  },
  methods: {
    onButtonAction(data) {},
    toClickAction(row, type) {
      const that = this
      this.$wtUtil.deleteConfirm(this, row.isPublish === 1 ? '确认禁用？' : '确认启用？').then(() => {
        that.$api.siteManage.site.siteIsPublish({
          id: row.id
        }).then(res => {
          that.$message({ message: '操作成功', type: 'success' })
          that.$refs.siteManageTableRef.requestList()
        })
      })
    },
    /*  ------------------------- 接口请求  -------------------------  */
    orgListSelect() {
      this.$api.siteManage.org.orgTreeListNoSite().then(res => {
		this.$wtUtil.setSiteLevelKey(res.data)
        this.form.formInputsData[1].options = res.data
      })
    }
  }
}
</script>

<style>
</style>
